import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const PRICE_API_URL = process.env.REACT_APP_PRICE_API_URL || 'http://localhost:8000';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const priceApi = axios.create({
  baseURL: PRICE_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

priceApi.interceptors.request.use((config) => {
  const apiKey = process.env.REACT_APP_PRICE_API_KEY;
  config.params = { ...config.params, apiKey };
  return config;
});

export const getAdminConfig = () => api.get('/api/admin/config');
export const getSymbols = () => priceApi.get('/api/symbols');
export const login = (emailOrMobile, password) => api.post('/api/login', { emailOrMobile, password });
export const register = (userData) => api.post('/api/register', userData);
export const logout = () => api.post('/api/logout');
export const getUser = () => api.get('/api/user');
export const updateUserKyc = (kycData) => api.put('/api/user/kyc', kycData);
export const updateUserBasicDetails = (basicData) => api.put('/api/user/basic-details', basicData);
export const updateUserBankDetails = (bankData) => api.put('/api/user/bank-details', bankData);
export const updateUserMarginSettings = (marginData) => api.put('/api/user/margin-settings', marginData);
export const getMarginSettings = () => api.get('/api/user/margin-settings');
export const getChartSettings = () => api.get('/api/settings/chart');
export const updateChartSettings = (settingsData) => api.put('/api/settings/chart', settingsData);
export const getCardSymbol = () => api.get('/api/settings/card-symbol');
export const updateCardSymbol = (cardSymbolData) => api.put('/api/settings/card-symbol', { cardSymbol: cardSymbolData });
export const getOrders = () => api.get('/api/orders');
export const placeOrder = (orderData) => api.post('/api/orders/place-order', orderData);
export const modifyOrder = (orderId, orderData) => api.put(`/api/orders/${orderId}`, orderData);
export const cancelOrder = (orderId) => api.delete(`/api/orders/${orderId}`);
export const addOrderQuantity = (orderId, qtyData) => api.put(`/api/orders/add-qty/${orderId}`, qtyData);
export const closePosition = (orderId, closePrice) => api.put(`/api/orders/close/${orderId}`, { closePrice });
export const convertPosition = (orderId) => api.put(`/api/orders/convert/${orderId}`);
export const getPortfolio = () => api.get('/api/portfolio');
export const getTransactions = () => api.get('/api/transactions');
export const getSingleTransaction = (transactionId) => api.get(`/api/transactions/${transactionId}`);
export const updateTransaction = (transactionId, txnData) => api.put(`/api/transactions/${transactionId}`, txnData);
export const initiateTransaction = (txnData) => api.post('/api/transactions/initiate', txnData);

export const uploadPaymentProof = (transactionId, formData) => api.post(`/api/transactions/${transactionId}/proof`, formData, {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

export const uploadKycDocument = (formData) => api.post(`/api/user/kyc-document`, formData, {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

export const updateUserAdditionalDetails = (additionalDetails) => api.put('/api/user/additional-details', additionalDetails);
export const cancelWithdrawal = (transactionId) => api.put(`/api/transactions/cancel/${transactionId}`);

export const getNotifications = () => api.get('/api/notifications');
export const markNotificationAsRead = (id) => api.put(`/api/notifications/read/${id}`);

// SYMBOL BASED WATCHLIST API
export const getWatchlists = () => api.get('/api/watchlist/all');
export const createWatchlist = (name) => api.post('/api/watchlist/create', { name });
export const deleteWatchlist = (name) => api.delete(`/api/watchlist/${name}`);
export const addToWatchlist = (symbol, watchlistName) => api.post('/api/watchlist/add', { symbol, watchlistName });
export const removeFromWatchlist = (symbol, watchlistName) => api.post('/api/watchlist/remove', { symbol, watchlistName });

export const getAdminBankDetails = () => api.get('/api/settings/bank-details');
export const getNews = () => api.get('/api/news');
// Support Tickets
export const createSupportTicket = (ticketData) => api.post('/api/support/create', ticketData);
export const uploadSupportScreenshot = (ticketId, formData) => api.post(`/api/support/${ticketId}/screenshot`, formData, {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});
export const getMySupportTickets = () => api.get('/api/support/my-tickets');

export default api;
